import axios from './base';

const login = body => axios.post('/api/v1/user/login', body);

export { login };
